import React from "react";
import ReactEcharts from "echarts-for-react";

const BandwidthPieChart = ({ height, color = [] }) => {
  const option = {
    color: ["#62549c", "#7566b5", "#7d6cbb", "#8877bd", "#9181bd", "#6957af"],
    tooltip: {
      show: true,
      backgroundColor: "rgba(0, 0, 0, .8)"
    },

    series: [
      {
        name: "Sales by Country",
        type: "pie",
        radius: "60%",
        center: ["50%", "50%"],
        data: [
          { value: 535, name: "ASP Agrigento" },
          { value: 310, name: "Garbagnate" },
          { value: 234, name: "Comune di Pisa" },
          { value: 155, name: "Unione Forlivese" },
          { value: 130, name: "ASS Friuli" },
          { value: 348, name: "Comune di Bari" }
        ],
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)"
          }
        }
      }
    ]
  };

  return <ReactEcharts style={{ height: height }} option={option} />;
};

export default BandwidthPieChart;
